import { render, staticRenderFns } from "./WarningModal3.vue?vue&type=template&id=f841a312&scoped=true"
import script from "./WarningModal3.vue?vue&type=script&lang=js"
export * from "./WarningModal3.vue?vue&type=script&lang=js"
import style0 from "./WarningModal3.vue?vue&type=style&index=0&id=f841a312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f841a312",
  null
  
)

export default component.exports